import type { SaleIncidentClass } from "./types";

export const saleIncidentClassLabels: Record<SaleIncidentClass, string> = {
  missing_diagnostics: "Нет диагностики",
  missing_next_step: "Нет next step",
  toxic_manager: "Токсичность менеджера",
  toxic_client: "Токсичность клиента",
  SLA_violation: "Нарушение SLA",
  negative_review_refusal: "Негативный отзыв",
  false_client_expectations: "Ложные ожидания клиента",
  poor_objection_handling: "Плохая отработка возражения",
};
